import { StorageItems } from '../../../shared/constants/app';
import {
  addItemToLocalstorage,
  getItemFromLocalStorage,
} from '../../../utilities/common/storage';

type AiChatConsentRecord = {
  userIds: string[];
};

const readConsentRecord = (): AiChatConsentRecord => {
  try {
    const stored = getItemFromLocalStorage(
      StorageItems.AI_CHAT_CONSENT,
      'object',
    ) as AiChatConsentRecord | null;

    if (!stored || !Array.isArray(stored.userIds)) {
      return { userIds: [] };
    }

    return { userIds: stored.userIds.filter((id) => typeof id === 'string') };
  } catch {
    return { userIds: [] };
  }
};

export const hasAiChatConsent = (userId: string): boolean => {
  if (!userId) return false;
  return readConsentRecord().userIds.includes(userId);
};

export const saveAiChatConsent = (userId: string): void => {
  if (!userId) return;

  const current = readConsentRecord();
  if (current.userIds.includes(userId)) return;

  addItemToLocalstorage(StorageItems.AI_CHAT_CONSENT, {
    userIds: [...current.userIds, userId],
  });
};
